import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { FigmaNode } from '../FigmaNode';

export type SelectedElementProps = {
  element?: Pick<SceneNode, 'id' | 'name' | 'type'> | null;
};

const StyledSelectedElement = styled('div')(({ theme }) => ({
  backgroundColor: 'var(--input-input-background-color)',
  borderRadius: theme.spacing(1),
  padding: `${theme.spacing(2.5)} ${theme.spacing(3)}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
}));

export const SelectedElement = ({ element }: SelectedElementProps) => {
  const { t } = useI18n();

  return (
    <StyledSelectedElement>
      {element ? (
        <FigmaNode element={element} />
      ) : (
        <Typography>{t('appraisals:no_page_selected')}</Typography>
      )}
    </StyledSelectedElement>
  );
};
